import gql from 'graphql-tag';
const HIGHLIGHT_IT_ACTIVITY_FRAGMENT = gql `
  fragment HighlightItActivityFragment on HighlightItActivity {
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
        description
      }
    }
    rounds {
      id
      numAnswers
      roundInstructions: instructions {
        id
        audioId
        audio {
          id
          src
          description
        }
      }
      hint {
        id
        audioId
        audio {
          id
          src
          description
        }
      }
      mainContent {
        id
        svgId
        svg {
          id
          src
        }
      }
      questionHtml {
        id
        elements
      }
    }
  }
`;
export default HIGHLIGHT_IT_ACTIVITY_FRAGMENT;
